import { tv } from 'tailwind-variants';

const buttonContentStyles = tv({
    slots: {
        icon: `
      iris:inline-flex
      iris:shrink-0
      iris:items-center
      iris:justify-center
    `,
        spinnerArc: "",
    },
    variants: {
        size: {
            sm: { icon: "iris:size-(--comp-size-icon-button-sm)" },
            md: { icon: "iris:size-(--comp-size-icon-button-md)" },
            lg: { icon: "iris:size-(--comp-size-icon-button-lg)" },
        },
        smSize: {
            sm: { icon: "iris:sm:size-(--comp-size-icon-button-sm)" },
            md: { icon: "iris:sm:size-(--comp-size-icon-button-md)" },
            lg: { icon: "iris:sm:size-(--comp-size-icon-button-lg)" },
        },
        mdSize: {
            sm: { icon: "iris:md:size-(--comp-size-icon-button-sm)" },
            md: { icon: "iris:md:size-(--comp-size-icon-button-md)" },
            lg: { icon: "iris:md:size-(--comp-size-icon-button-lg)" },
        },
        lgSize: {
            sm: { icon: "iris:lg:size-(--comp-size-icon-button-sm)" },
            md: { icon: "iris:lg:size-(--comp-size-icon-button-md)" },
            lg: { icon: "iris:lg:size-(--comp-size-icon-button-lg)" },
        },
        variant: {
            primary: {},
            secondary: {},
            tertiary: {},
            unstyled: {},
        },
        inverse: {
            false: {},
            true: {},
        },
    },
    compoundVariants: [
        {
            variant: "primary",
            inverse: false,
            class: {
                spinnerArc: "iris:stroke-(--comp-color-content-button-primary-disabled)",
            },
        },
        {
            variant: "primary",
            inverse: true,
            class: {
                spinnerArc: "iris:stroke-(--comp-color-content-button-primary-inverse-disabled)",
            },
        },
        {
            variant: "secondary",
            inverse: false,
            class: {
                spinnerArc: "iris:stroke-(--comp-color-content-button-secondary-disabled)",
            },
        },
        {
            variant: "secondary",
            inverse: true,
            class: {
                spinnerArc: "iris:stroke-(--comp-color-content-button-secondary-inverse-disabled)",
            },
        },
        {
            variant: "tertiary",
            inverse: false,
            class: {
                spinnerArc: "iris:stroke-(--comp-color-content-button-tertiary-disabled)",
            },
        },
        {
            variant: "tertiary",
            inverse: true,
            class: {
                spinnerArc: "iris:stroke-(--comp-color-content-button-tertiary-inverse-disabled)",
            },
        },
    ],
    defaultVariants: {
        size: "md",
        variant: "primary",
        inverse: false,
    },
});

export { buttonContentStyles as default };
